import React from "react";
import './topBox.css';
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { store } from "../../redux/store";
import tokenErrorHandler from "../tokenErrorHandler";
import { totalActiveConsumers, totalConsumerNo, totalInActiveConsumers } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class HeaderConsumer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            totalActives: 0,
            totalInactives: 0,
            consumerList: [],
        }
    }
    totalActives = [];
    totalInactives = [];

    componentDidMount() {
        this.loadConsumerList();

    }

    componentWillUnmount() {
    }

    loadConsumerList = () => {
        
        var url = '/api/v1/billpay/corp/consumer/get-list/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }
        this.setState({
            consumerStat: 'loading'
        })

        url = url + this.props.agentInfo + '/all/all';
        var totalActives = 0;
        var totalInactives = 0;
        httpClient.get(url,
            { headers }
        ).then((response) => {

            this.setState({
                consumerStat: 'completed'
            })

            if (response.data != undefined &&
                response.data != null &&
                response.data != '') {
                store.dispatch(totalConsumerNo(response.data.length));

                if (response.data.length > 0) {
                    response.data.map(res => {
                        if (res.active == true) {
                            totalActives++;
                        }
                        if (res.active == false) {
                            totalInactives++;
                        }
                    })
                }
                setTimeout(() => {
                    store.dispatch(totalActiveConsumers(totalActives));
                    store.dispatch(totalInActiveConsumers(totalInactives));
                }, 400);
            }
        }).catch(error => {
            store.dispatch(totalConsumerNo(0));
            this.setState({
                consumerStat: 'completed'
            })


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });
    }
    render() {

        return (

            <div class="col-12 col-md-6 col-lg order-lg-1">
                <div class="card">
                    <div class="top-box">

                        <Link to="/all-consumer" class="lbbtn">View all</Link>
                        <i class="alluser"></i>
                        <p>Total Consumers</p>
                        {this.props.totalConsumers}
                    </div>
                    <div class="more-box">
                        <p class="float-start">Active: <span class="active">{this.props.actives}</span></p>
                        <p class="float-end">Inactive: <span class="inactive">{this.props.inActives}</span></p>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, },
        miscReduce: { agentInfo, phone, actives, inActives, totalConsumers } }
) => ({
    errorMessage, agentInfo, phone, actives, inActives, totalConsumers
});

export default connect(mapStateToProps, null)(HeaderConsumer);
